<h3 mat-dialog-title>{{titulo}}</h3>
<div mat-dialog-content style="width: 100%">


    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }} </small>
                    <small *ngIf="cliente.assessor != undefined && cliente.assessor != null"> <b> | </b> Assessor: {{cliente.assessor.name }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>


    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id == 7 || usuario.role_id == 4' fxFlex="100">
            <mat-label>Escritório</mat-label>
            <mat-select 
                placeholder="Escritório" 
                [(value)]="model.escritorio_id"
                [formControl]="escritorio_id" 
                (selectionChange)="selectEscritorio($event)">
                <mat-option value="">TODOS</mat-option>
                <mat-option *ngFor="let escritorio of listEscritorios"
                    [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        
        <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id != 5' fxFlex="100">
            <mat-label>Assessor</mat-label>
            <mat-select placeholder="Assessor"
                        [(value)]="model.assessor_id" 
                        [formControl]="assessor_id"
                        name="assessor_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
        </mat-form-field>
    
    </div>

    <div fxLayout="column" fxLayout.gt-md="row" *ngIf="data.tipo != 'incosistencia' ">

        <mat-form-field appearance="outline" style="width: 40%; margin-right: 10px;">
            <mat-label>Tipo</mat-label>
            <mat-select placeholder="Tipo"                        
                        [formControl]="tipo_percentual"
                        name="tipo_percentual" >                
                <mat-option value="MA">Maior que</mat-option>
                <mat-option value="ME">Menor que</mat-option>
                <mat-option value="IG">Igual a </mat-option>                
                <mat-option value="DI">Diferente de </mat-option>                
            </mat-select>                   
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 55%">
            <mat-label>Percentual</mat-label>
            <input 
                matInput 
                placeholder="00.0%" 
                [formControl]="percentual" 
                name="percentual" 
                maxlength="4"
                mask="00.0 %">
        </mat-form-field>

    </div>

   

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>